import { c as _c } from "react/compiler-runtime";
import { formatUserRoleType } from "@utils/data-display";
import { Text } from "@flat-ui";
import { FaroTextField } from "@components/common/faro-text-field/faro-text-field";
/**
 * Read-only display of a member's role.
 * Used across different role column components (company, project, group).
 *
 * @param role - The role to display
 * @returns Formatted role text
 */
export function MemberRoleReadOnly(t0) {
  const $ = _c(6);
  const {
    role,
    variant
  } = t0;
  let t1;
  if ($[0] !== role) {
    t1 = formatUserRoleType(role);
    $[0] = role;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const formattedRole = t1;
  if (variant !== "standard") {
    let t2;
    if ($[2] !== formattedRole) {
      t2 = <Text variant="bodyS">{formattedRole}</Text>;
      $[2] = formattedRole;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== formattedRole) {
    t2 = <FaroTextField label="Workspace role" initialValue={formattedRole} faroVariant="main" fontSize="18px" />;
    $[4] = formattedRole;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}